<template>
    <button class="filter-badge mr-2 mb-2" @click.prevent=""
            :class="{'filter-badge--disabled':disabled}"
            :content="flairText" v-tippy="{theme: 'light', arrow:true}">
        <span class="flair-text">{{ flairText }}</span>
        <a v-if="!hideCloseButton" @click.prevent="$emit('click')" e2e-id="flair-close">
            <icon-component :icon="fa_times()"></icon-component>
        </a>
    </button>
</template>

<script>

import {fa_times} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";

export default {
    components: {IconComponent},
    methods: {fa_times},
    props: ['flair', 'flairText', 'disabled','hideCloseButton'],
}
</script>
